<template>
    <div class="page-header">
        <div class="page-header-content header-elements-md-inline">
            <div class="page-title d-flex">
                <h4>{{ $t(`pages.${routeName}`) }}</h4>
                <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
            </div>

            <div class="header-elements d-none py-0 mb-3 mb-md-0">
                <div class="breadcrumb">
                    <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
                        <router-link v-if="breadcrumb.linkName" :to="{name: breadcrumb.linkName}" class="breadcrumb-item">
                            {{ breadcrumb.name }}
                        </router-link>
                        <span v-else class="breadcrumb-item active" >{{ breadcrumb.name }}</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "PageHeader",
    computed: {
        routeName() {
            const pageMatch = this.$route.matched.find((route) => !route.meta?.isLayout) ?? this.$route.matched[this.$route.matched.length - 1];

            return pageMatch.name
        },
        breadcrumbs() {
            return this.$route.matched.reduce((acc, route) => {
                acc = acc.concat(route.meta.breadcrumb())

                return acc
            }, [])
        }
    },
}
</script>
